import { Dispatch } from 'react'

import { doc, getDoc } from 'firebase/firestore'

import { buildRoutinesWithContent } from './routineSelectors'
import { Routines } from '../../components/users/professors/Students/RoutineSection'
import { DEFAULT_TRAINING_TYPE_TABS } from '../../constants/tracks'
import { NewLog } from '../../types'
import { firestore } from '../firebaseConfig'

function mergeTrainingCategories(
  firestoreItems: string[] | undefined,
  logs: NewLog[],
) {
  const base = firestoreItems?.length ? [...firestoreItems] : []
  for (const tab of DEFAULT_TRAINING_TYPE_TABS) {
    if (!base.includes(tab)) base.push(tab)
  }
  for (const log of logs) {
    for (const exercise of log.exercises) {
      const rootCategory = exercise.category[0]
      if (rootCategory && !base.includes(rootCategory)) {
        base.push(rootCategory)
      }
    }
  }
  return base
}

export const getRoutinesNames = async (
  studentLogs: NewLog[] | null,
  setExerByCat: Dispatch<React.SetStateAction<Routines[] | null>>,
) => {
  try {
    if (!studentLogs) return

    const docRef = doc(firestore, 'lists', 'trainingType')
    const docSnapshot = await getDoc(docRef)

    const fromDoc = docSnapshot.exists()
      ? (docSnapshot.data().items as string[])
      : undefined
    const categories = mergeTrainingCategories(fromDoc, studentLogs)

    setExerByCat(buildRoutinesWithContent(studentLogs, categories))
  } catch (error) {
    console.error('Error accediendo a la lista de entrenamiento:')
  }
}
